<template>
    <section :class="{ 'full-page': isBig, 'inline-styling': !isBig }">
        <section class="component">
            <section class="component__header">
                <span class="component__header__title">
                    {{$t('com.file.custom-css-settings.css-settings')}}
                </span>
                <section class="component__header__action">
                    <button class="component__button component__button--small component__button--white"
                            @click="toogleEditor()">
                        <img src="@/assets/icons/components/up-right-and-down-left-from-center.svg" v-if="!isBig" width="20" />
                        <img src="@/assets/icons/components/arrow-down-left-and-arrow-up-right-to-center.svg" v-else width="20" />

                    </button>
                    <button class="component__button component__button--small component__button--white"
                            @click="save()">
                        <span class="component__button__text">{{$t('com.global.save')}}</span>
                    </button>
                </section>
            </section>
            <section class="component__body custom-css-editor-wrapper">
                <label class="custom-css-label">CSS</label>
                <textarea class="custom-css-textarea" v-model="customCss.styles"
                          spellcheck="false" placeholder="/* CSS */"></textarea>
                <section class="custom-css-metadata">
                    <span v-if="customCss.revision &&customCss.revision !== 0">{{$t('com.file.user-last-logins-modal.date')}}: {{ formatDate(customCss.created) }}</span>
                    <span v-if="customCss.revision && customCss.revision !== 0">{{$t('com.file.announcements.author')}}: {{ customCss.user?.firstName }} {{ customCss.user?.lastName }}</span>
                    <span v-if="customCss.revision &&customCss.revision !== 0">{{$t('com.file.custom-css-settings.revision')}}: <span class="link">{{ customCss.revision }}</span></span>
                </section>
            </section>
            <SmallLoader v-if="isLoading" />
        </section>
    </section>
</template>
<script charset="utf-8">
    import customCssService from '../../../../../services/custom.css.service';
    import SmallLoader from "../../../../BasicControls/SmallLoader.vue";
    import moment from "moment";

    export default {
        name: "CustomCssSettings",
        components: {
            SmallLoader
        },
        data() {
            return {
                isLoading: false,
                customCss: {
                    styles: ""
                },
                isBig: false,
            }
        },
        async mounted() {
            try {
                this.isLoading = true;
                await this.internalFetch();
            }
            finally {
                this.isLoading = false;
            }
        },
        methods: {
            async internalFetch() {
                let response = await customCssService.getNewest();
                if (response.status !== 200) {
                    throw await Promise.reject(response);
                }
                const data = response.data || {};
                this.customCss = { ...data, styles: (data.styles ?? "").toString() };
            },
            async save() {
                try {
                    this.isLoading = true;
                    await customCssService.create(this.customCss);
                    await this.internalFetch();
                }
                finally {
                    this.isLoading = false;
                }
            },
            toogleEditor() {
                this.isBig = !this.isBig;
            },
            formatDate(date) {
                return moment(date).format("YYYY-MM-DD HH:mm");
            }
        }
    }
</script>
<style lang="scss">
    @use "@/assets/scss/user-profile-component.scss";

    .component {
        position: relative;
    }

    .component__body {
        overflow: hidden;
        min-width: 0;
    }

    .custom-css-editor-wrapper {
        display: flex;
        flex-direction: column;
        min-height: 0;
        overflow: hidden;
        margin: 16px;
    }

    .custom-css-label {
        display: block;
        margin: 0px 0px 10px 10px;
        font-weight: 500;
        font-size: 14px;
        color: #808396;
        font-style: italic;
    }

    .custom-css-textarea {
        flex: 1;
        min-height: 450px;
        min-width: 0;
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
        padding: 16px;
        font-family: monospace;
        font-size: 13px;
        line-height: 1.5;
        border: 1px solid #ddd;
        border-radius: 4px;
        resize: vertical;
        background: #f8f9fa;
    }

    .custom-css-textarea:focus {
        outline: none;
        border-color: #6c63ff;
        background: #fff;
    }

    .full-page {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 90;
        width: 100vw;
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;

        .component {
            width: 80vw;

            &__body {
                height: 80vh;
            }
        }
    }

    .custom-css-metadata {
        padding: 5px 10px;
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        column-gap: 5px;
        font-weight: 300;
        font-size: 0.75em;
        color: #808396;
        font-style: italic;
    }

    .component__header__action {
        display: flex;
        flex-direction: row;
        column-gap: 10px;
    }

    .inline-styling {
        flex-grow: 1;
    }
</style>